import { LIST_TYPE_ROAD } from "@/constants/list-type-roads";

export const isValidRoadType = (roadType) => {
  return LIST_TYPE_ROAD.some((item) => item.value === roadType);
};

export const isValidStreetName = (value) => {
  if (!value) {
    return false;
  }
  const regex = /[^a-zA-Z0-9.ñáéíóúÁÉÍÓÚ´/ ]/g;
  return !regex.test(value);
};

export const isValidStreetNumber = (value) =>
  value !== "" && !isNaN(Number(value));
